export default "__VITE_ASSET__c57617a2__"